<nb-card class="main-card" [ngClass]="{ 'nb-card--thin': mode == EMode.NEW }">
  <nb-card-header>
    <app-avatar [name]="employee?.firstName" [avatarUrl]="employee?.avatarUrl"> </app-avatar>
    <div class="support-id" *ngIf="!!tmpData.id">(Support Id: {{ tmpData.id }})</div></nb-card-header
  >
  <nb-card-body>
    <!--    <div class="row">-->
    <!--    <div class="col-12">-->
    <div [ngClass]="{ 'left-wrapper': true, 'left-wrapper--update-mode': mode == EMode.UPDATE }">
      <div class="row">
        <div class="col-4"><label>Type:</label></div>
        <div class="col-8">
          <nb-radio-group name="turn-type" [(ngModel)]="typeOption">
            <nb-radio *ngFor="let option of typeOptions" [value]="option.value">
              {{ option.label }}
            </nb-radio>
          </nb-radio-group>
        </div>
      </div>
      <ng-container *ngIf="typeOption == 'normal'">
        <div class="row no-border">
          <div class="col-4"><label>Amt:</label></div>
          <div class="col-8">
            <input
              class="input-amt"
              #amt
              nbInput
              type="text"
              appCurrencyInput
              [(ngModel)]="tmpData.amt"
              placeholder="Amt"
              (ngModelChange)="onChangeAmt()"
            />
          </div>
        </div>
        <div class="row no-border row--cash-wrapper">
          <div class="col-4">
            <label>Paid in cash:</label>
            <div class="in-cash-icon"></div>
          </div>
          <div class="col-8">
            <nb-radio-group name="cash-option" [(ngModel)]="cashOption" (ngModelChange)="onChangeAmt()">
              <nb-radio *ngFor="let option of cashOptions" [value]="option.value">
                {{ option.label }}
              </nb-radio>
            </nb-radio-group>
            <input
              *ngIf="cashOption == 'custom'"
              class="input-amt"
              nbInput
              type="text"
              appCurrencyInput
              [(ngModel)]="tmpData.paidInCashAmt"
              (ngModelChange)="onChangeAmt()"
              placeholder="Cash"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <div class="amt-estimate">
              <p class="amt-due-wrapper">
                <span class="title">Amount Due (Tax included):</span>
                <span class="amt-due">{{ amtTaxIncluded || 0 | AmountPipe }}</span>
              </p>
              <ng-container *ngIf="cashOption !== 'custom'">
                <p class="amt-card-wrapper">
                  <span class="title">Pay All by Credit Card{{ CREDIT_CARD_FEE ? ' (fees included)' : '' }}:</span>
                  <span class="amt-card">{{ cardEstimation || 0 | AmountPipe }}</span>
                </p>
              </ng-container>
              <ng-container *ngIf="cashOption !== 'custom'">
                <p class="amt-cash-wrapper">
                  <span class="title">
                    Pay all in cash{{ CASH_DISCOUNT_PERCENT ? ' (' + CASH_DISCOUNT_PERCENT + '% off)' : '' }}:</span
                  >
                  <span class="amt-cash">{{ cashEstimation || 0 | AmountPipe }}</span>
                </p>
              </ng-container>
              <ng-container *ngIf="cashOption === 'custom'">
                <p class="amt-card-wrapper">
                  <span class="title"
                    >Remaining Amount to Pay by Credit Card{{ CREDIT_CARD_FEE ? ' (fees included)' : '' }}:</span
                  >
                  <span class="amt-card">{{ cardEstimation || 0 | AmountPipe }}</span>
                </p>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4"><label>Tip:</label></div>
          <div class="col-8">
            <input class="input-amt" nbInput type="text" appCurrencyInput [(ngModel)]="tmpData.tip" placeholder="Tip" />
          </div>
        </div>
        <div class="row">
          <div class="col-4"><label>Redeem?:</label></div>
          <div class="col-8">
            <nb-radio-group class="radio-input-combine" name="redeem-option" [(ngModel)]="redeemOption">
              <nb-radio
                *ngFor="let option of redeemOptions"
                [value]="option.value"
                (valueChange)="onRedeemOptionsChange($event)"
              >
                {{ option.label }}
                <ng-container *ngIf="option.value == 'yes'"
                  ><nb-icon icon="gift-outline" status="info"></nb-icon
                ></ng-container>
              </nb-radio>
            </nb-radio-group>
            <!--              <input-->
            <!--                *ngIf="redeemOption == 'yes'"-->
            <!--                class="input-amt"-->
            <!--                nbInput-->
            <!--                type="number"-->
            <!--                [(ngModel)]="tmpData.redeemAmt"-->
            <!--                placeholder="Amt"-->
            <!--              />-->
            <button *ngIf="redeemOption == 'yes'" size="small" (click)="onRedeemDetailClick()" nbButton status="info">
              ${{ tmpData.redeemAmt || 0 | AmountPipe }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-4"><label>Client requested?:</label></div>
          <div class="col-8">
            <nb-radio-group name="client-requested" [(ngModel)]="clientRequested">
              <nb-radio *ngFor="let option of clientRequestedOptions" [value]="option.value">
                {{ option.label }}
                <ng-container *ngIf="option.value == 'yes'"
                  ><nb-icon icon="heart" status="danger"></nb-icon
                ></ng-container>
              </nb-radio>
            </nb-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-4"><label>Payment:</label></div>
          <div class="col-8">
            <nb-radio-group name="payment-status" [(ngModel)]="tmpData.paymentStatus">
              <nb-radio *ngFor="let option of paymentStatusOptions" [value]="option.value">
                {{ option.label }}
              </nb-radio>
            </nb-radio-group>
          </div>
        </div>
      </ng-container>
      <div class="crying-container" *ngIf="typeOption == 'crying'"></div>
      <div class="row no-border">
        <div class="col-4"><label>Note:</label></div>
        <div class="col-8">
          <input fullWidth nbInput type="text" [(ngModel)]="tmpData.note" placeholder="Note" />
        </div>
      </div>
    </div>
    <div *ngIf="mode == EMode.UPDATE" class="turn-history">
      <h6>HISTORY</h6>
      <ng-container *ngFor="let h of tmpData?.histories">
        <a [ngClass]="currentHistoryId == h.id ? 'history-selected' : ''" (click)="onClickHistory(h)">
          {{ h.updatedAt | date: 'yyyy-MM-dd HH:mm:ss' }} -
          {{ h.operator?.firstName }}
          {{ h.operationType === 'create' ? 'created' : 'updated' }}
        </a>
      </ng-container>
    </div>
    <!--    </div>-->
    <!--    </div>-->
  </nb-card-body>
  <nb-card-footer>
    <button *ngIf="mode === EMode.NEW" [disabled]="!allowOkButtonClick" nbButton (click)="onOk()" status="success">
      <nb-icon icon="checkmark-outline"></nb-icon>OK
    </button>
    <button *ngIf="mode === EMode.UPDATE" [disabled]="!allowOkButtonClick" nbButton (click)="onOk()" status="success">
      <nb-icon icon="save-outline"></nb-icon>SAVE
    </button>
    <button class="right-button" nbButton (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>CANCEL</button>
    <button *ngIf="mode === EMode.UPDATE" nbButton (click)="onDelete()" status="danger">
      <nb-icon icon="trash-outline"></nb-icon>DELETE
    </button>
  </nb-card-footer>
</nb-card>
